/* Copyright (c) Librestream Technologies. All rights reserved. */
/* eslint-disable */ 

const LOGGER_INFO_EN = true;
const LOGGER_ERROR_EN = true;
const LOGGER_WARN_EN = true;
const LOGGER_DEBUG_EN = true;

export default function logger() {
}

logger.info = function(en, tag, message) {
	if (en && LOGGER_INFO_EN) {
		console.info("[" + tag + "]", message);
	}
}

logger.debug = function(en, tag, message) {
	if (en && LOGGER_DEBUG_EN) {
		console.debug("[" + tag + "]", message);
	}
}

logger.warn = function(en, tag, message) {
	if (en && LOGGER_WARN_EN) {
		console.warn("[" + tag + "]", message);
	}
}

logger.error = function(en, tag, message) {
	if (en && LOGGER_ERROR_EN) {
		console.error("[" + tag + "]", message);
	}
}